module.exports = __webpack_public_path__ + "media/images/navigation/contact-d579ac6909b1f0361366bd2c648e295e.gif";